import * as React from 'react';

import { Button, cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { $scaleForm, ScaleFormState } from '../../../_state/scaleForm.state';
import { useTranslations } from '../../../i18n/useTranslations';

type Props = {
  isSaving?: boolean;
  onSaveUpdates?: (data?: ScaleFormState) => void;
  onDiscard?: () => void;
};

export const ScaleFormFooterActions: React.FC<Props> = ({
  isSaving,
  onSaveUpdates,
  onDiscard,
}) => {
  const t = useTranslations();
  const form = useAtomValue($scaleForm);

  return (
    <div
      className={cn(
        '@ScaleFormFooterActions',
        'sticky bottom-0 mt-5 flex flex-0 justify-end gap-3 border-t border-neutral/10 bg-white px-6 pt-5 pb-5',
      )}
    >
      <Button
        color="neutral"
        variant="outline"
        onPress={() => onDiscard?.()}
        isDisabled={isSaving}
      >
        {t.hardwareView.scaleDetailView.footer.discard}
      </Button>
      <Button
        color="primary"
        variant="solid"
        onPress={() => onSaveUpdates?.(form)}
        isPending={isSaving}
        isLoading={isSaving}
      >
        {t.hardwareView.scaleDetailView.footer.saveUpdates}
      </Button>
    </div>
  );
};
